import { getCampaignData } from "../../../services/api/GoogleApi";
import { getReport } from "../../../services/api/Report"
import { constructKpis } from "./constructKpis";

export const handleOldReport = (
    campaigns, 
    id, 
    report, 
    setReport, 
    googleResponses, 
    setGoogleResponses, 
    managerAccessToken, 
    managerAccountId, 
    clientId,
    lang, 
    t, 
    alertMessage, 
    navigate
) => {
    return new Promise((resolve, reject) => {
        getReport(id).then((res) => {
            const savedReport = res.data?.data?.report;
            setGoogleResponses({...googleResponses, campaigns: campaigns})
            setReport(savedReport);
            for ( let campaign of savedReport.campaigns ) {
                getCampaignData(clientId, managerAccountId, campaign.campaign.id, managerAccessToken, report?.dates)
                .then((response) => {
                    const getCampaignData = response?.data?.data?.campaignData;
                    const campaignData = googleResponses.campaignData;
                    if ( getCampaignData[0] ) {
                        campaignData.push({
                            campaign: getCampaignData[0]?.campaign,
                            metrics: getCampaignData[0]?.metrics,
                            kpis: constructKpis(getCampaignData[0])
                        });
                        setGoogleResponses({...googleResponses, campaigns: campaigns, campaignData: campaignData})
                    }
                })
                .catch(error=>{
                    console.error(error); 
                    alertMessage((t("Session expired")),'Error');
                    navigate(`/${lang}/google/connect`);
                })
            }
        }).catch(err=>{
            console.error(err)
            alertMessage((t("Session expired")),'Error');
            navigate(`/${lang}/google/connect`);
        })
    })
}